module.exports = __webpack_public_path__ + "img/noHistory.8308f095.png";